
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import 'react';
import { cardContainer } from './styles.js';
import CardHeader from './Header.js';
import Thumbnail from './Thumbnail.js';
import Hover from './Hover.js';
import Body from './Body.js';
import Overlay from './Overlay.js';
import Drawer from './Drawer.js';
import { createElement as jsx } from '../../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js';
import { AnimatePresence } from '../../../node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs.js';
import { m } from '../../../node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs.js';
import { domAnimation } from '../../../node_modules/framer-motion/dist/es/render/dom/features-animation.mjs.js';
import { LazyMotion } from '../../../node_modules/framer-motion/dist/es/components/LazyMotion/index.mjs.js';

var _excluded = ["disableHover", "hasBorder", "children"];
var Card = function Card(_ref) {
  var _ref$disableHover = _ref.disableHover,
    disableHover = _ref$disableHover === void 0 ? false : _ref$disableHover,
    _ref$hasBorder = _ref.hasBorder,
    hasBorder = _ref$hasBorder === void 0 ? true : _ref$hasBorder,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return jsx(LazyMotion, {
    features: domAnimation
  }, jsx(AnimatePresence, null, jsx(m.article, _extends({
    initial: "rest",
    whileHover: !disableHover ? "hover" : {},
    css: function css(theme) {
      return cardContainer(theme, {
        hasBorder: hasBorder
      });
    },
    "data-testid": "card"
  }, rest), children)));
};
Card.Header = CardHeader;
Card.Thumbnail = Thumbnail;
Card.Hover = Hover;
Card.Body = Body;
Card.Overlay = Overlay;
Card.Drawer = Drawer;

export { Card as default };
//# sourceMappingURL=Card.js.map
